import axios from 'axios';
import Cookies from 'js-cookie';

// The back-office is authenticated by the Django session cookie: send it on every request,
// including the ones made with the global axios instance.
axios.defaults.withCredentials = true;

const axiosApiInstance = axios.create({ withCredentials: true });

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async config => {
    // const value = await redisClient.get(rediskey)
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    };

    config.headers = headers;
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// The server session is gone (expired, logged out, or never opened): drop the client side login
// state so the layout sends the user back to the login page.
function onUnauthorized(error) {
  if (error && error.response && error.response.status === 401) {
    localStorage.removeItem('authedUser');
    Cookies.remove('authedUser');
    if (!window.location.hash.startsWith('#/system/')) {
      window.location.hash = '#/system/login';
    }
  }
  return Promise.reject(error);
}
axios.interceptors.response.use(response => response, onUnauthorized);
axiosApiInstance.interceptors.response.use(response => response, onUnauthorized);

export default axiosApiInstance;

/*
// Response interceptor for API calls
axiosApiInstance.interceptors.response.use(
  response => {
    return response
  },
  async function(error) {
    const originalRequest = error.config
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true
      const access_token = await refreshAccessToken()
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token
      return axiosApiInstance(originalRequest)
    }
    return Promise.reject(error)
  },
)
*/
